<template>
    <div class="roleManager">
        <HandMenu/>
        <el-card shadow="never" style="border: 0;border-right: 1px solid #EBEEF5;">
            <el-row :gutter="20">
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                </el-breadcrumb>
                <div v-loading="loading">
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                        <el-input placeholder="搜索角色名" v-model="roleName"
                                  class="input-with-select">
                        </el-input>
                    </el-col>
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="24" :md="24" :lg="9" :xl="12">
                        <el-button type="primary" @click="selectTable" plain>搜索</el-button>
                        <el-button type="success" @click="clearSelect" plain>清空</el-button>
                        <el-button type="info" @click="refreshTable" plain>刷新</el-button>
                        <el-button type="warning" @click="addDialogVisible=true" plain>添加角色</el-button>
                    </el-col>
                    <el-table
                            :data="tableData"
                            border
                            :header-cell-style="cellStyle"
                            :cell-style="cellStyle"
                            style="width: 100%">
                        <el-table-column
                                fixed
                                type="index"
                                label="#"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="roleName"
                                label="角色名"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="roleCreateTime"
                                :formatter="dateFormat"
                                label="创建时间"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="roleUpdateTime"
                                :formatter="dateFormat"
                                label="更新时间"
                        >
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="150">
                            <template slot-scope="scope">
                                <el-button slot="reference" type="text" size="small"
                                           @click="openChangeDialog(scope.row)">修改
                                </el-button>
                                <!--删除内容的按钮-->
                                <el-popconfirm
                                        style="margin-left: 10px;"
                                        icon="el-icon-info"
                                        iconColor="red"
                                        title="删除后对应该角色的账号会被修改为'支部账号'角色！"
                                        @onConfirm="deleteRoleInf(scope.row)"
                                >
                                    <el-button slot="reference" type="text" size="small">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页器-->
                    <div class="block" style="margin-top: 10px;text-align: right">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 20, 30]"
                                :page-size="10"
                                layout="prev, pager, next, jumper,sizes"
                                :total="roleTotal">
                        </el-pagination>
                    </div>
                </div>
            </el-row>
        </el-card>
        <!--########添加角色对话框#########-->
        <el-dialog
                title="添加角色"
                :visible.sync="addDialogVisible"
                width="30%">
            <!--账号输入框-->
            <div>
                <el-input placeholder="请输入角色名" v-model="addRoleName">
                    <template slot="prepend">角色名：</template>
                </el-input>
            </div>
            <el-row :gutter="12">
                <el-col :span="8" style="margin-top: 10px" v-for="limit in addSelectLimitList" :key="limit.limitId">
                    <el-card shadow="always" body-style="padding:10px;">
                        <el-switch
                                v-model="limit.state"
                                :active-text="limit.limitName"
                        >
                        </el-switch>
                        <!--                        <span style="line-height: 2;">{{}}</span>-->
                    </el-card>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addRole">确 定</el-button>
            </span>
        </el-dialog>

        <!--########修改角色对话框#########-->
        <el-dialog
                title="修改角色"
                :visible.sync="changeDialogVisible"
                width="30%">
            <!--账号输入框-->
            <div>
                <el-input placeholder="请输入角色名" v-model="changeRoleName">
                    <template slot="prepend">角色名：</template>
                </el-input>
            </div>
            <el-row :gutter="12">
                <el-col :span="8" style="margin-top: 10px" v-for="limit in changeSelectLimitList" :key="limit.limitId">
                    <el-card shadow="always" body-style="padding:10px;">
                        <el-switch
                                v-model="limit.state"
                                :active-text="limit.limitName"
                        >
                        </el-switch>
                    </el-card>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
            <el-button @click="changeDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateRoleInf">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import axios from "../../api";
    import moment from 'moment'
    import Vue from "../../main";

    export default {
        name: "RoleManager",
        data() {
            return {
                roleName: "",
                //表格内容
                tableData: [],
                //-------------分页器 --------
                // 当前页数
                currentPage: 1,
                //分页器 每页显示几条
                pageSize: 10,
                //总共有多少条数据
                roleTotal: 0,
                //------------加载遮罩----------
                loading: false,
                //-----------添加弹窗----------
                addDialogVisible: false,
                addRoleName: "",
                addSelectLimitList: [],
                //-----------修改弹窗----------
                changeRoleInf: {},
                changeDialogVisible: false,
                changeRoleName: "",
                changeSelectLimitList: [],
            }
        },
        methods: {
            //清除搜索框
            clearSelect() {
                this.roleName = "";
            },
            //分页器 当前每页几条
            handleSizeChange(val) {
                this.loading = true;
                this.pageSize = val;
                this.getTableData();
            },
            //分页器当前在第几页
            handleCurrentChange(val) {
                this.loading = true;
                this.currentPage = val;
                this.getTableData();
            },
            cellStyle({columnIndex}) {
                //让序号那一列居中
                if (columnIndex === 0) {
                    // 指定列号
                    return 'text-align: center;'
                } else {
                    return ''
                }
            },
            //刷新表格
            refreshTable() {
                //获取内容
                this.getTableData();
            },
            //搜索
            selectTable() {
                //设置当前页为1
                this.currentPage = 1;
                //获取内容
                this.getTableData();
            },
            //时间格式化
            dateFormat(row, column) {
                const daterc = row[column.property]
                if (daterc == undefined) {
                    return ''
                }
                return moment(daterc).format("YYYY-MM-DD")
            },
            //获取角色信息
            getTableData() {
                let self = this;
                axios.getRoleInfTable({
                    //当前页
                    page: self.currentPage,
                    //每页显示几条
                    showCount: self.pageSize,
                    //搜索角色名
                    roleName: self.roleName
                }).then(res => {
                    console.log(res.data.roleInf);
                    self.tableData = res.data.roleInf.records;
                    //设置总页数
                    self.roleTotal = res.data.roleInf.total;
                    self.loading = false;
                })
            },
            //获取所有权限
            getLimitInf() {
                let self = this;
                axios.getLimitInf().then(res => {
                    let limitList = res.data.limitList;
                    for (let i = 0; i < limitList.length; i++) {
                        limitList[i].state = false
                    }
                    self.addSelectLimitList = JSON.parse(JSON.stringify(limitList));
                    self.changeSelectLimitList = JSON.parse(JSON.stringify(limitList));
                })
            },
            //添加角色
            addRole() {
                //处理数据
                let self = this;
                if (self.addRoleName.replace(/\s*/g, "") === "" || self.addRoleName == null) {
                    Vue.$message({
                        message: "请输入角色名！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                //获取选中的权限
                let limit = self.addSelectLimitList;
                let limitList = [];
                for (let i = 0; i < limit.length; i++) {
                    if (limit[i].state === true) {
                        //如果是true说明是选中
                        limitList.push(limit[i].limitId);
                    }
                }
                if (limitList.length === 0) {
                    Vue.$message({
                        message: "至少选择一种权限！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }
                //执行添加
                let limitString = JSON.stringify(limitList);
                axios.insertRole({
                    roleName: self.addRoleName,
                    limitString
                }).then(res => {
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "success"
                        });
                        self.addDialogVisible = false;
                        //清空输入组
                        self.addRoleName = "";
                        for (let i = 0; i < self.addSelectLimitList.length; i++) {
                            self.addSelectLimitList[i].state = false
                        }
                        //设置当前页为1
                        self.currentPage = 1;
                        //获取内容
                        self.getTableData();
                    } else {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            openChangeDialog(row) {
                let self = this;
                self.changeRoleInf = row;
                axios.getRoleLimit({
                    roleId: row.roleId
                }).then(res => {
                    let limitList = res.data.roleLimitList;
                    //还原开关
                    for (let j = 0; j < self.changeSelectLimitList.length; j++) {
                        self.changeSelectLimitList[j].state = false;
                    }

                    for (let i = 0; i < limitList.length; i++) {
                        for (let j = 0; j < self.changeSelectLimitList.length; j++) {
                            if (limitList[i].limitId === self.changeSelectLimitList[j].limitId) {
                                self.changeSelectLimitList[j].state = true;
                                break;
                            }
                        }
                    }
                    //设置修改的角色名
                    self.changeRoleName = row.roleName;
                    //打开修改框
                    self.changeDialogVisible = true;
                })
            },
            updateRoleInf() {
                //获取权限
                let self = this;
                //判断是否是默认的两个角色
                if (self.changeRoleInf.roleState === 1) {
                    Vue.$message({
                        message: "不予许修改该角色！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }


                if (self.changeRoleName.replace(/\s*/g, "") === "" || self.changeRoleName == null) {
                    Vue.$message({
                        message: "请输入角色名！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                //获取选中的权限
                let limit = self.changeSelectLimitList;
                let limitList = [];
                for (let i = 0; i < limit.length; i++) {
                    if (limit[i].state === true) {
                        //如果是true说明是选中
                        limitList.push(limit[i].limitId);
                    }
                }
                if (limitList.length === 0) {
                    Vue.$message({
                        message: "至少选择一种权限！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                //执行修改
                let limitString = JSON.stringify(limitList)
                axios.updateRoleInf({
                    roleId: self.changeRoleInf.roleId,
                    roleName: self.changeRoleName,
                    limitString: limitString
                }).then(res => {
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "success"
                        });
                        self.changeDialogVisible = false;
                        //获取内容
                        self.getTableData();
                    } else {
                        Vue.$message({
                            message: "出现意外错误，请联系开发人员！",
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            //删除角色
            deleteRoleInf(row) {
                let self = this;
                axios.deleteRoleInf({
                    roleId: row.roleId
                }).then(res => {
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "success"
                        });
                        //设置当前页为1
                        this.currentPage = 1;
                        //获取内容
                        self.getTableData();
                    } else {
                        Vue.$message({
                            message: "出现意外错误，请联系开发人员！",
                            duration: 1500,
                            type: "error"
                        });
                    }
                })

            }
        },
        mounted() {
            this.getTableData();
            this.getLimitInf();
        }
    }
</script>

<style scoped>
    .roleManager {
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }
</style>
